function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Insider Logo");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M23,41.15H37.3v75.5H23Z",
  transform: "translate(-4.7 -2.99)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M50.89,41.15H64.67L97,90.83V41.15h14.37v75.5H97.52L65.26,67.12v49.53H50.89Z",
  transform: "translate(-4.7 -2.99)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M183.75,51.41,173.11,60.8Q167.5,53,161.69,53a6.94,6.94,0,0,0-4.63,1.51,4.41,4.41,0,0,0-1.8,3.41,5.84,5.84,0,0,0,1.29,3.59q1.75,2.26,10.54,9.7,8.23,6.88,10,8.67a30.1,30.1,0,0,1,6.19,8.44,21.08,21.08,0,0,1,1.83,8.8,20.18,20.18,0,0,1-6.42,15.35q-6.42,6.06-16.75,6.06a24.91,24.91,0,0,1-14.05-4q-6-4-10.25-12.42l12.08-7.29q5.45,10,12.54,10a9.24,9.24,0,0,0,6.22-2.16,6.41,6.41,0,0,0,2.52-5,8.6,8.6,0,0,0-1.9-5.13q-1.9-2.57-8.38-7.85-12.34-10.06-15.94-15.53a19.72,19.72,0,0,1-3.6-10.91,17.83,17.83,0,0,1,6-13.47,20.76,20.76,0,0,1,14.77-5.62,23.31,23.31,0,0,1,10.77,2.62Q177.79,44.48,183.75,51.41Z",
  transform: "translate(-4.7 -2.99)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M195.14,41.15H209.4v75.5H195.14Z",
  transform: "translate(-4.7 -2.99)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M223,41.15h17q16.46,0,24.46,4.08t13.18,13.27a43,43,0,0,1,5.18,21.45,43.19,43.19,0,0,1-2.9,16,33.28,33.28,0,0,1-8,12.14,28.25,28.25,0,0,1-11.05,6.67q-5.95,1.85-20.61,1.85H223ZM237.26,55v47.63h6.67q9.85,0,14.29-2.26a17.13,17.13,0,0,0,7.26-7.6,27.9,27.9,0,0,0,2.82-13.15q0-12-6.72-18.65-6.06-6-19.45-6Z",
  transform: "translate(-4.7 -2.99)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M294,41.15h41.21V55.21H308.23V68.86h26.94V82.67H308.23v19.86h26.94v14.11H294Z",
  transform: "translate(-4.7 -2.99)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M346.92,41.15h15.23q12.51,0,17.81,2.23a18.26,18.26,0,0,1,8.54,7.42,22.72,22.72,0,0,1,3.23,12.27,20.9,20.9,0,0,1-3.57,12.45q-3.57,5-10.75,7.57l17.89,33.57H379.59l-17-32h-1.32v32H346.92Zm14.37,29.51h4.5q6.86,0,9.44-1.8t2.58-6a7.31,7.31,0,0,0-1.28-4.3A7.1,7.1,0,0,0,373.11,56q-2.15-.8-7.88-.8h-3.94Z",
  transform: "translate(-4.7 -2.99)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#28aae1",
  d: "M4.7,3V157H130V3ZM117.82,137.27,11.76,150V10l106.35,6.49Z",
  transform: "translate(-4.7 -2.99)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 390.59 154.02"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/insider-logo.0363befc.svg";
export { SvgComponent as ReactComponent };